const MonthConvert_year = (string) => {
  const monthMap = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  };
    var [year,month, day] = string.split('-');
    string =  day + '. ' + monthMap[month] + ' ' + year;
    return string;
}
const MonthConvert = (string) => {
  const monthMap = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  };
    var [month, day] = string.split('-');
    string =  day + '. ' + monthMap[month];
    return string;
}
export { MonthConvert, MonthConvert_year }
